import React from 'react'

const Content = () => {
  return (
    <div>
      <h1>Content</h1>
    </div>
  )
}

export default Content
